import Cover from '../components/slides/Cover';
import Hero from '../components/slides/Hero';
import Horizon from '../components/slides/Horizon';
import ListSlide from '../components/slides/ListSlide';
import TableSlide from '../components/slides/TableSlide';
import CompanyContext from '../components/slides/CompanyContext';
import AIIdeation from '../components/slides/AIIdeation';
import Prioritization from '../components/slides/Prioritization';
import ProjectCharter from '../components/slides/ProjectCharter';
import DesignMockup from '../components/slides/DesignMockup';
import VideoMockup from '../components/slides/VideoMockup';
import QuadrantSlide from '../components/slides/QuadrantSlide';
import SectionCover from '../components/slides/SectionCover';
import CircleHero from '../components/slides/CircleHero';

const slideComponents = {
  cover: Cover,
  Cover: Cover, // Handle both camelCase and PascalCase
  hero: Hero,
  horizon: Horizon,
  list: ListSlide,
  table: TableSlide,
  companyContext: CompanyContext,
  CompanyContext: CompanyContext, // Handle both camelCase and PascalCase
  aiIdeation: AIIdeation,
  AIIdeation: AIIdeation, // Handle both camelCase and PascalCase
  prioritization: Prioritization,
  projectCharter: ProjectCharter,
  ProjectCharter: ProjectCharter, // Handle both camelCase and PascalCase
  designMockup: DesignMockup,
  DesignMockup: DesignMockup, // Handle both camelCase and PascalCase
  videoMockup: VideoMockup,
  VideoMockup: VideoMockup, // Handle both camelCase and PascalCase
  quadrant: QuadrantSlide,
  Quadrant: QuadrantSlide, // Handle both camelCase and PascalCase
  sectioncover: SectionCover,
  SectionCover: SectionCover, // Handle both camelCase and PascalCase
  circlehero: CircleHero,
  CircleHero: CircleHero, // Handle both camelCase and PascalCase
};

export const getSlides = (slides) => {
  return slides.map((slide) => {
    const SlideComponent = slideComponents[slide.slide_type];
    if (!SlideComponent) {
      // eslint-disable-next-line no-console
      console.warn(`Unknown slide type: ${slide.slide_type}`);
      // eslint-disable-next-line no-console
      console.warn('Available slide types:', Object.keys(slideComponents));
      return null;
    }
    return {
      ...slide,
      component: SlideComponent,
    };
  }).filter(Boolean);
};


// Normalize Strapi v5 response into internal deck shape
export function normalizeStrapiDeck(apiJson) {
  const attrs = apiJson?.data?.attributes || {};
  const slides = Array.isArray(attrs.slides) ? attrs.slides : [];
  const norm = slides.map((s, i) => {
    const base = typeof s === 'object' && s ? { ...s } : {};
    return {
      order: base.order ?? i + 1,
      slide_type: base.slide_type,
      title: base.title || "",
      subtitle: base.subtitle || "",
      image_url: base.image_url || "",
      paragraph: base.paragraph || "",
      table_json: base.table_json || null,
      callout: base.callout || "",
      list_items: Array.isArray(base.list_items) ? base.list_items : [],
      phases: Array.isArray(base.phases) ? base.phases : [],
      layout: base.layout || "Vertical",
      ...base
    };
  });
  return {
    title: attrs.title || "Untitled Deck",
    description: attrs.description || "",
    slides: norm.sort((a, b) => (a.order || 0) - (b.order || 0))
  };
}

// Normalize direct CMS JSON (no Strapi wrapper) into internal deck shape
export function normalizeCmsDeck(apiJson) {
  // Handle both direct CMS response and Strapi-wrapped response
  let slidesData;
  if (apiJson?.data?.attributes?.slides) {
    // Strapi v5 structure with populate
    slidesData = apiJson.data.attributes.slides;
  } else if (Array.isArray(apiJson?.slides)) {
    // Direct CMS response
    slidesData = apiJson.slides;
  } else {
    slidesData = [];
  }
  
  const normalizedSlides = slidesData.map((slide, index) => {
    const base = typeof slide === 'object' && slide ? { ...slide } : {};
    const normalized = {
      order: base.order ?? index + 1,
      slide_type: base.slide_type,
      title: base.title || "",
      subtitle: base.subtitle || "",
      image_url: base.image_url || "",
      paragraph: base.paragraph || "",
      table_json: base.table_json || null,
      callout: base.callout || "",
      list_items: Array.isArray(base.list_items) ? base.list_items : [],
      phases: Array.isArray(base.phases) ? base.phases : [],
      layout: base.layout || "Vertical",
      ...base,
    };
    return normalized;
  });

  // Handle both direct CMS response and Strapi-wrapped response for deck metadata
  let deckTitle, deckDescription, deckAccentColor;
  if (apiJson?.data?.attributes) {
    // Strapi v5 structure
    deckTitle = apiJson.data.attributes.title;
    deckDescription = apiJson.data.attributes.description;
    deckAccentColor = apiJson.data.attributes.accent_color;
  } else {
    // Direct CMS response
    deckTitle = apiJson?.title;
    deckDescription = apiJson?.description;
    deckAccentColor = apiJson?.accent_color;
  }

  const result = {
    title: deckTitle || "Untitled Deck",
    description: deckDescription || "",
    accent_color: deckAccentColor,
    slides: normalizedSlides.sort((a, b) => (a.order || 0) - (b.order || 0)),
  };
  
  return result;
}